var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "entryManagerModal",
            size: "xl",
            "content-class": "menu-bg-blue-transparent-modal dpr-em-modal",
            "body-class": "scroll-Container",
            title: "Daily Productivity Report Entry Manager",
            scrollable: "",
            "hide-footer": "",
          },
          on: {
            show: function ($event) {
              return _vm.initDPREntryManager()
            },
          },
        },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c("MMP_QueryConstructor", {
                attrs: {
                  comp: "DPR",
                  fromdate: _vm.fromdate,
                  todate: _vm.todate,
                  isAdmin: _vm.isAdmin,
                  user: _vm.user,
                  getConditions: _vm.getConditions,
                },
                on: {
                  applyCustomQuery: function ($event) {
                    return _vm.applyCustomQuery($event)
                  },
                },
              }),
              _vm._v(" "),
              _c("b-row", { staticClass: "mx-1 mt-3" }, [
                _vm._v(" Time Range "),
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mx-2 my-3" },
                [
                  _c("b-col", { staticClass: "col-sm-3" }, [
                    _c("label", { staticClass: "form-check-label" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filterType,
                            expression: "filterType",
                          },
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          name: "optDateFilter",
                          id: "allDay",
                          value: "allDay",
                          checked: "",
                        },
                        domProps: { checked: _vm._q(_vm.filterType, "allDay") },
                        on: {
                          change: [
                            function ($event) {
                              _vm.filterType = "allDay"
                            },
                            function ($event) {
                              return _vm.dateInput()
                            },
                          ],
                        },
                      }),
                      _vm._v("Single Day\n          "),
                    ]),
                    _vm._v(" "),
                    _c("label", { staticClass: "form-check-label chk-align" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filterType,
                            expression: "filterType",
                          },
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "radio",
                          name: "optDateFilter",
                          id: "dateRange",
                          value: "range",
                        },
                        domProps: { checked: _vm._q(_vm.filterType, "range") },
                        on: {
                          change: [
                            function ($event) {
                              _vm.filterType = "range"
                            },
                            function ($event) {
                              return _vm.dateInput()
                            },
                          ],
                        },
                      }),
                      _vm._v("Date Range\n          "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "col-sm-8 form-check-inline align" },
                    [
                      _c("b-form-input", {
                        staticClass: "form-control col-sm-3 propStyle",
                        attrs: {
                          type: "date",
                          placeholder: "From date",
                          format: "dd/MM/yyyy",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.loadEntryManager()
                          },
                        },
                        model: {
                          value: _vm.fromdate,
                          callback: function ($$v) {
                            _vm.fromdate = $$v
                          },
                          expression: "fromdate",
                        },
                      }),
                      _vm._v(" "),
                      _vm.filterType != "allDay"
                        ? _c("label", { staticClass: "mx-3" }, [_vm._v("TO")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.filterType != "allDay"
                        ? _c("b-form-input", {
                            staticClass: "form-control col-sm-3 propStyle",
                            attrs: {
                              type: "date",
                              placeholder: "To date",
                              format: "dd/MM/yyyy",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.loadEntryManager()
                              },
                            },
                            model: {
                              value: _vm.todate,
                              callback: function ($$v) {
                                _vm.todate = $$v
                              },
                              expression: "todate",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-link",
                        {
                          staticClass: "btn-margin link",
                          attrs: { size: "md" },
                          on: {
                            click: function ($event) {
                              return _vm.loadEntryManager(_vm.isAdmin)
                            },
                          },
                        },
                        [_vm._v("\n            Filter\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-link",
                        {
                          staticClass: "btn-margin link",
                          attrs: { size: "md" },
                          on: {
                            click: function ($event) {
                              return _vm.loadMissingReports()
                            },
                          },
                        },
                        [_vm._v("\n            Missing Entries\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.entryManagerSpinner
                ? _c("vue-bootstrap4-table", {
                    attrs: {
                      rows: _vm.entryManagerRows,
                      columns: _vm.entryManagerColumns,
                      config: _vm.config,
                      actions: _vm.isAdmin ? _vm.adminActions : _vm.actions,
                      classes: _vm.classes,
                    },
                    on: {
                      downloadCsv: function ($event) {
                        return _vm.downloadCsv()
                      },
                      openDPR: function ($event) {
                        return _vm.initDprModal()
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "Collection Day",
                          fn: function (props) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDateForDisplay(
                                      props.row["Collection Day"]
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "Full Day Downtime Reason",
                          fn: function (props) {
                            return [
                              props.row["Full Day Downtime Reason"]
                                ? _c(
                                    "div",
                                    { staticClass: "downDayHighlight" },
                                    [
                                      _c("span", [
                                        _c("strong", [_vm._v("Full Day: ")]),
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              props.row[
                                                "Full Day Downtime Reason"
                                              ]
                                            ) +
                                            "\n            "
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              props.row["Partial Day Downtime Reason"]
                                ? _c(
                                    "div",
                                    { staticClass: "partialDownDayHighlight" },
                                    [
                                      _vm.isAdmin
                                        ? _c("fa", {
                                            staticClass: "float-right m-1",
                                            staticStyle: { cursor: "pointer" },
                                            attrs: {
                                              icon: ["fas", "window-close"],
                                              title:
                                                "Remove Partial Downtime Reason",
                                              size: "sm",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.clearPartialDowntime(
                                                  props.row
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", [
                                        _c("strong", [_vm._v("Partial Day: ")]),
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              props.row[
                                                "Partial Day Downtime Reason"
                                              ]
                                            ) +
                                            "\n              (" +
                                            _vm._s(
                                              props.row["hours_dt_partial"]
                                            ) +
                                            " hours)\n            "
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !props.row["Partial Day Downtime Reason"] &&
                              _vm.isAdmin
                                ? _c(
                                    "b-button",
                                    {
                                      staticClass: "mt-2",
                                      attrs: { size: "sm", variant: "warning" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showReasonDropdown(
                                            props.row.vbt_id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("fa", {
                                        attrs: {
                                          icon: ["fas", "pen-square"],
                                          size: "lg",
                                          title: "Update downtime",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.reasonQuickEditManager[props.row.vbt_id - 1]
                                ? _c(
                                    "b-form-select",
                                    {
                                      staticClass: "mt-2",
                                      attrs: { id: "partialDowntimeReason" },
                                      on: {
                                        change: function ($event) {
                                          return _vm.submitChanges(props.row)
                                        },
                                      },
                                      model: {
                                        value: _vm.selectedDownTimeReason,
                                        callback: function ($$v) {
                                          _vm.selectedDownTimeReason = $$v
                                        },
                                        expression: "selectedDownTimeReason",
                                      },
                                    },
                                    _vm._l(
                                      _vm.downtimeReasons,
                                      function (reason, index) {
                                        return _c(
                                          "option",
                                          {
                                            key: index,
                                            domProps: {
                                              value: {
                                                reason: reason,
                                                index: index,
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(reason) +
                                                "\n            "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: "Comments",
                          fn: function (props) {
                            return [
                              _c("span", { staticClass: "comments-text" }, [
                                _vm._v(_vm._s(props.row["Comments"])),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "validated",
                          fn: function (props) {
                            return [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: {
                                    value: true,
                                    "unchecked-value": false,
                                    switch: "",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.toggleValidated(props.row)
                                    },
                                  },
                                  model: {
                                    value: props.row["validated"],
                                    callback: function ($$v) {
                                      _vm.$set(props.row, "validated", $$v)
                                    },
                                    expression: "props.row['validated']",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      class: props.row["validated"]
                                        ? "text-success font-weight-bold"
                                        : "text-danger font-weight-bold",
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            props.row["validated"]
                                              ? "Yes"
                                              : "No"
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "update",
                          fn: function (props) {
                            return [
                              _c("fa", {
                                staticStyle: { cursor: "pointer" },
                                attrs: {
                                  icon: ["fas", "pencil-alt"],
                                  size: "lg",
                                  variant: "primary",
                                  title: "Update entry",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.updateEntry(props.row)
                                  },
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "delete",
                          fn: function (props) {
                            return _vm.isAdmin
                              ? [
                                  _c("fa", {
                                    staticStyle: { cursor: "pointer" },
                                    attrs: {
                                      icon: ["fas", "trash"],
                                      size: "lg",
                                      title: "Delete entry",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteEntry(props.row)
                                      },
                                    },
                                  }),
                                ]
                              : undefined
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.entryManagerSpinner
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-center align-items-center py-1",
                    },
                    [
                      _c("span", {
                        staticClass:
                          "spinner-border spinner-border-md highlightLoader",
                        attrs: { role: "status", "aria-hidden": "true" },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "highlightLoader p-1 spinner-border-md",
                        },
                        [_vm._v("Loading Data...")]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("MMP_DPR_MissingEntriesModal", {
            attrs: { entries: _vm.missingEntries },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }